/**
 * @generated SignedSource<<6162e92673e9806bd9d19128180fe53b>>
 * @relayHash 9c4e4065cf45754abf63ff88e975e71c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e3b245fa39498d8ec6c516668aea1ebd2b78ec08310df23c1cc5b6bb994ec84f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_CUSTOMER_SERVICE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type JiraResourceIntegration = "ATTACHMENT" | "CONFLUENCE" | "GDRIVE" | "LOOM" | "WEBLINK" | "WHITEBOARD" | "%future added value";
export type JiraResourcesOrderField = "CREATED" | "FILENAME" | "FILESIZE" | "MIMETYPE" | "%future added value";
export type JiraResourcesSortDirection = "ASC" | "DESC" | "%future added value";
export type JiraIssueResourceFilters = {
  integration?: JiraResourceIntegration | null;
  types?: ReadonlyArray<string | null> | null;
};
export type workItemViewResourcesQuery$variables = {
  after?: string | null;
  applicationKey: JiraApplicationKey;
  cloudId: string;
  filters?: ReadonlyArray<JiraIssueResourceFilters | null> | null;
  first: number;
  hydrate?: boolean | null;
  isTwcCoUseRovoCheckEnabled: boolean;
  isTwcEntitlementCheckEnabled: boolean;
  issueKey: string;
  issueViewAddAttachmentFlag: boolean;
  orderDirection?: JiraResourcesSortDirection | null;
  orderField?: JiraResourcesOrderField | null;
  productKey: string;
};
export type workItemViewResourcesQuery$data = {
  readonly resourcesEmptyStateTwcCoUseEntitlement?: {
    readonly " $fragmentSpreads": FragmentRefs<"ResourcesEmptyState_twcCoUseEntitlement">;
  } | null;
  readonly twcEligibilityTwcEntitlement?: {
    readonly " $fragmentSpreads": FragmentRefs<"useTwcEligibility_twcEntitlement">;
  } | null;
  readonly workItemAttachmentsViewTwcCoUseEntitlement?: {
    readonly " $fragmentSpreads": FragmentRefs<"WorkItemAttachmentsView_twcCoUseEntitlement">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkItemAttachments_paginationQuery">;
};
export type workItemViewResourcesQuery = {
  response: workItemViewResourcesQuery$data;
  variables: workItemViewResourcesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hydrate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTwcCoUseRovoCheckEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTwcEntitlementCheckEnabled"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueViewAddAttachmentFlag"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderField"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v13 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v14 = {
  "kind": "Variable",
  "name": "applicationKey",
  "variableName": "applicationKey"
},
v15 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v16 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v17 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v18 = {
  "kind": "Variable",
  "name": "hydrate",
  "variableName": "hydrate"
},
v19 = {
  "kind": "Variable",
  "name": "orderDirection",
  "variableName": "orderDirection"
},
v20 = {
  "kind": "Variable",
  "name": "orderField",
  "variableName": "orderField"
},
v21 = [
  (v15/*: any*/),
  {
    "kind": "Variable",
    "name": "productKey",
    "variableName": "productKey"
  }
],
v22 = [
  (v14/*: any*/),
  (v15/*: any*/)
],
v23 = [
  (v13/*: any*/),
  (v17/*: any*/),
  {
    "fields": [
      (v16/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v24 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v25 = {
  "kind": "ScalarField",
  "name": "id"
},
v26 = {
  "kind": "ScalarField",
  "name": "integration"
},
v27 = {
  "kind": "ScalarField",
  "name": "name"
},
v28 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    {
      "kind": "ScalarField",
      "name": "accountId"
    },
    (v27/*: any*/),
    {
      "kind": "ScalarField",
      "name": "picture"
    },
    (v25/*: any*/)
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "href"
},
v30 = {
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "cloudIds.0",
          "variableName": "cloudId"
        }
      ],
      "kind": "ListValue",
      "name": "cloudIds"
    }
  ],
  "concreteType": "TenantContext",
  "kind": "LinkedField",
  "name": "tenantContexts",
  "plural": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "hamsProductKey",
          "variableName": "productKey"
        }
      ],
      "kind": "LinkedField",
      "name": "entitlementInfo",
      "plural": false,
      "selections": [
        (v24/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "collectionEntitlement",
              "args": [
                {
                  "kind": "Literal",
                  "name": "where",
                  "value": {
                    "hasRelationshipFromWithType": "COLLECTION"
                  }
                }
              ],
              "concreteType": "CcpEntitlement",
              "kind": "LinkedField",
              "name": "entitlement",
              "plural": false,
              "selections": [
                (v24/*: any*/),
                (v25/*: any*/)
              ],
              "storageKey": "entitlement(where:{\"hasRelationshipFromWithType\":\"COLLECTION\"})"
            }
          ],
          "type": "CommerceEntitlementInfoCcp"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "workItemViewResourcesQuery",
    "selections": [
      {
        "args": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "kind": "Variable",
            "name": "issueKey",
            "variableName": "issueKey"
          },
          {
            "kind": "Variable",
            "name": "issueViewAddAttachmentFlag",
            "variableName": "issueViewAddAttachmentFlag"
          },
          (v19/*: any*/),
          (v20/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "WorkItemAttachments_paginationQuery"
      },
      {
        "condition": "isTwcEntitlementCheckEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v21/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "useTwcEligibility_twcEntitlement"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "twcEligibilityTwcEntitlement"
          }
        ]
      },
      {
        "condition": "isTwcCoUseRovoCheckEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v21/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "WorkItemAttachmentsView_twcCoUseEntitlement"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "workItemAttachmentsViewTwcCoUseEntitlement"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v21/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "ResourcesEmptyState_twcCoUseEntitlement"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "resourcesEmptyStateTwcCoUseEntitlement"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "workItemViewResourcesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "issueViewAddAttachmentFlag",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v22/*: any*/),
                "kind": "ScalarField",
                "name": "attachmentStorageAllowed"
              },
              {
                "args": (v22/*: any*/),
                "kind": "ScalarField",
                "name": "attachmentStorageUsed"
              },
              {
                "args": (v22/*: any*/),
                "kind": "ScalarField",
                "name": "attachmentStorageIsUnlimited"
              }
            ]
          },
          {
            "args": [
              (v15/*: any*/),
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "issueKey"
              }
            ],
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "args": (v23/*: any*/),
                "concreteType": "JiraConsolidatedResourceConnection",
                "kind": "LinkedField",
                "name": "consolidatedResources",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraConsolidatedResourcesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "createdDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "contentType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fileName"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "mediaApiFileId"
                              },
                              (v26/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "parent"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "parentId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "hasRestrictedParent"
                              },
                              (v28/*: any*/)
                            ],
                            "type": "JiraAttachmentResource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v29/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isExternallyLinked"
                              },
                              (v28/*: any*/)
                            ],
                            "type": "JiraConfluenceLinkResource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v29/*: any*/),
                              (v26/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "iconUrl"
                              },
                              (v28/*: any*/)
                            ],
                            "type": "JiraRemoteLinkResource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v29/*: any*/),
                              (v28/*: any*/)
                            ],
                            "type": "JiraWhiteboardResource"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fileSize"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  },
                  (v24/*: any*/)
                ]
              },
              {
                "args": (v23/*: any*/),
                "filters": [
                  "input"
                ],
                "handle": "connection",
                "key": "WorkItemAttachments_consolidatedResources",
                "kind": "LinkedHandle",
                "name": "consolidatedResources"
              },
              (v25/*: any*/),
              {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  (v25/*: any*/)
                ]
              },
              {
                "concreteType": "JiraProjectField",
                "kind": "LinkedField",
                "name": "projectField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "projectId"
                      },
                      (v25/*: any*/)
                    ]
                  },
                  (v25/*: any*/)
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "input",
                    "value": {
                      "integration": [
                        "ATTACHMENT",
                        "CONFLUENCE",
                        "LOOM",
                        "WHITEBOARD",
                        "WEBLINK"
                      ]
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "getConsolidatedResourcesTotalCount",
                "storageKey": "getConsolidatedResourcesTotalCount(input:{\"integration\":[\"ATTACHMENT\",\"CONFLUENCE\",\"LOOM\",\"WHITEBOARD\",\"WEBLINK\"]})"
              },
              {
                "alias": "allLinksTotalCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "input",
                    "value": {
                      "integration": [
                        "CONFLUENCE",
                        "LOOM",
                        "WHITEBOARD",
                        "WEBLINK"
                      ]
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "getConsolidatedResourcesTotalCount",
                "storageKey": "getConsolidatedResourcesTotalCount(input:{\"integration\":[\"CONFLUENCE\",\"LOOM\",\"WHITEBOARD\",\"WEBLINK\"]})"
              },
              {
                "kind": "ScalarField",
                "name": "deletableAttachmentsCount"
              },
              {
                "kind": "ScalarField",
                "name": "totalAttachmentsCount"
              }
            ]
          }
        ]
      },
      {
        "condition": "isTwcEntitlementCheckEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v30/*: any*/)
        ]
      },
      {
        "condition": "isTwcCoUseRovoCheckEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v15/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "isRovoLLMEnabled"
              }
            ]
          },
          (v30/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "e3b245fa39498d8ec6c516668aea1ebd2b78ec08310df23c1cc5b6bb994ec84f",
    "metadata": {},
    "name": "workItemViewResourcesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "80364bdd44433260adf772f41bb39741";

export default node;
